/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DaysOfWeekMask } from './daysOfWeekMask';
import { PricingType } from './pricingType';
import { DayBadgeDto } from './dayBadgeDto';
import { RateType } from './rateType';


export interface LocationRateDto { 
    id?: number;
    locationId?: number;
    rateType?: RateType;
    hour?: number;
    untilTimeOfDay?: string | null;
    nextDayShiftThreshold?: string | null;
    readonly nextDayShiftThresholdFormatted?: string | null;
    rate?: number;
    displayName?: string | null;
    displayOrder?: number;
    isActive?: boolean;
    startDateTime?: string | null;
    endDateTime?: string | null;
    expiryTimeOfDay?: string | null;
    sameDayExpiry?: boolean;
    validFromTimeOfDay?: string | null;
    validToTimeOfDay?: string | null;
    availableDays?: DaysOfWeekMask;
    readonly availableDaysPretty?: Array<DayBadgeDto> | null;
    taxType?: PricingType;
    readonly taxTypeFormatted?: string | null;
    tax?: number | null;
    readonly taxFormatted?: string | null;
    serviceFeeType?: PricingType;
    readonly serviceFeeTypeFormatted?: string | null;
    serviceFee?: number | null;
    readonly serviceFeeFormatted?: string | null;
}
export namespace LocationRateDto {
}


